"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeQuestionChallenge = void 0;
const _1 = require(".");
const QuestionChallengeAnswer_1 = require("./QuestionChallengeAnswer");
function makeQuestionChallenge() {
    return new QuestionChallengeImp();
}
exports.makeQuestionChallenge = makeQuestionChallenge;
class QuestionChallengeImp {
    constructor() {
        this.answerLookup = new Map();
        this.observers = new _1.ObserverList();
        this._tries = 0;
        this._gotItRight = false;
        this.memoizedText = new _1.MemoizedString("", this.observers.notify);
        this.generateID = () => {
            const randomNumber = Math.random() * Date.now();
            return `${randomNumber}`;
        };
        this.setIDGenerator = (generator) => {
            this.generateID = generator;
        };
        this.getAllAnswers = () => {
            return Array.from(this.answerLookup.values());
        };
        this.addAnswer = (answer) => {
            if (this.answerLookup.has(answer.id)) {
                console.warn(`Answer with ID ${answer.id} already exists. Overwriting`);
            }
            this.answerLookup.set(answer.id, answer);
            this.reset();
        };
        this.removeAnswer = (id) => {
            const answer = this.answerLookup.get(id);
            if (!answer)
                return;
            this.answerLookup.delete(id);
            this.reset();
        };
        this.getAnswer = (id) => {
            return this.answerLookup.get(id);
        };
        this.hasAnswer = (id) => {
            return this.answerLookup.has(id);
        };
        this.reset = () => {
            this._gotItRight = false;
            this._tries = 0;
            this.answerLookup.forEach((ans) => (ans.showFeedback = false));
            this.observers.notify();
        };
        this.submitAnswer = (id) => {
            const ans = this.getAnswer(id);
            if (!ans) {
                console.warn(`[Question Challenge] Unable to find answer by ID:  ${id}`);
                return;
            }
            this._tries++;
            ans.showFeedback = true;
            this._gotItRight = ans.isCorrect;
            this.observers.notify();
        };
        this.createAnswer = (text) => {
            const id = this.generateID();
            const answer = QuestionChallengeAnswer_1.makeQuestionChallengeAnswer(id);
            answer.text = text;
            this.addAnswer(answer);
            return answer;
        };
        this.removeAllAnswers = () => {
            const allAnswers = Array.from(this.answerLookup.keys());
            allAnswers.forEach((id) => this.removeAnswer(id));
            this.reset();
        };
        this.setDefaultState = () => {
            this.removeAllAnswers();
            const trueAnswer = this.createAnswer("True");
            trueAnswer.isCorrect = true;
            this.createAnswer("False");
            this.memoizedText.setValQuietly("True / False question text");
            this.reset();
        };
        this.addObserver = (observer) => {
            this.observers.add(observer);
        };
        this.removeObserver = (observer) => {
            this.observers.remove(observer);
        };
    }
    get tries() {
        return this._tries;
    }
    get gotItRight() {
        return this._gotItRight;
    }
    get text() {
        return this.memoizedText.val;
    }
    set text(val) {
        this.memoizedText.val = val;
    }
}
